import React from 'react'
import { BulkAssignResultsProps } from './types'
import { ResultsWrapper, Instructions, ErrorMessage } from './styles'

const BulkAssignResults: React.FC<BulkAssignResultsProps> = ({ uploadResults, error }) => {
  const { data = [], errors = [] } = uploadResults || {}
  const hasErrors = (errors?.length ?? 0) > 0 || !!error
  const rowCount = Array.isArray(data) ? data.length : 0

  return (
    <ResultsWrapper hasErrors={hasErrors}>
      <span>{`${rowCount} rows processed`}</span>
      
      {hasErrors && (
        <Instructions>
          Please fix the following errors and re-upload
        </Instructions>
      )}
      
      {error && <ErrorMessage>Error: {error}</ErrorMessage>}
      
      {errors?.map((err, index) => (
        <ErrorMessage key={`error-${index}`}>
          Error: {err}
        </ErrorMessage>
      ))}
    </ResultsWrapper>
  )
}

export default BulkAssignResults

